import React from 'react';
import { palette } from '../../styles/theme';

export function ChargebacksSVG ({ className = '', stroke = palette.primary[700], width = 20, height = 20, strokeWidthArrow = 1.5, strokeWidthLine = 3 }) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
        >
            <g clipPath="url(#clip0_arrow_bar)">
                <path d="M4 12H14" stroke={stroke} strokeWidth={strokeWidthArrow} strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4 12L8 16" stroke={stroke} strokeWidth={strokeWidthArrow} strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4 12L8 8" stroke={stroke} strokeWidth={strokeWidthArrow} strokeLinecap="round" strokeLinejoin="round" />
                <path d="M20 4V20" stroke={stroke} strokeWidth={strokeWidthLine} strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_arrow_bar">
                    <rect width={width} height={height} fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
